import type { TMediaAnalysisRecord } from 'app/queries/media/collectMediaAnalysisRecords';

export const needsLegacyAnalysisLookup = (record: TMediaAnalysisRecord | undefined) =>
  record !== undefined && record.analysisStatus === null && record.duration === 0;
